/**
 * PagosWrapper — Tab "Pagos" en Ajustes (rc18+).
 *
 * Sub-tabs internos: Configuración (PagosSection) + Excepciones (DLQ).
 */
import { useState } from "react";
import { useQuery } from "@tanstack/react-query";
import { Settings, AlertTriangle, RefreshCcw } from "lucide-react";
import { Tabs, TabsContent, TabsList, TabsTrigger } from "@/components/ui/tabs";
import { PagosSection } from "./PagosSection";
import { PagosExcepcionesSection } from "./PagosExcepcionesSection";
import { PagosAuditoriaSection } from "./PagosAuditoriaSection";
import { apiCall } from "@/lib/api";

type ExceptionsCounts = {
  counts_by_status: Record<string, number>;
  counts_by_severidad: Record<string, number>;
};

function useOpenExceptionsCount() {
  return useQuery<ExceptionsCounts>({
    queryKey: ["toku-exceptions-counts"],
    queryFn: async () => {
      // Llamada barata solo para obtener counts
      const resp = await apiCall<{ counts_by_status: Record<string, number>; counts_by_severidad: Record<string, number> }>(
        "get",
        "/api/v1/integrations/payments/exceptions?page=1&page_size=1&status=open",
      );
      return resp;
    },
    staleTime: 30_000,
    refetchInterval: 60_000,
  });
}

export function PagosWrapper() {
  const [tab, setTab] = useState("config");
  const { data: counts } = useOpenExceptionsCount();
  const openCount = counts?.counts_by_status?.open || 0;
  const criticalCount = counts?.counts_by_severidad?.critical || 0;

  return (
    <Tabs value={tab} onValueChange={setTab}>
      <TabsList>
        <TabsTrigger value="config">
          <Settings size={12} className="mr-1" />
          Configuración
        </TabsTrigger>
        <TabsTrigger value="excepciones">
          <AlertTriangle size={12} className="mr-1" />
          Excepciones
          {openCount > 0 && (
            <span className={`ml-1.5 rounded-full px-1.5 py-0.5 text-[10px] font-semibold ${
              criticalCount > 0
                ? "bg-red-500 text-white"
                : "bg-amber-500 text-white"
            }`}>
              {openCount}
            </span>
          )}
        </TabsTrigger>
        <TabsTrigger value="auditoria">
          <RefreshCcw size={12} className="mr-1" />
          Auditoría sync
        </TabsTrigger>
      </TabsList>

      <TabsContent value="config">
        <PagosSection />
      </TabsContent>

      <TabsContent value="excepciones">
        <PagosExcepcionesSection />
      </TabsContent>

      <TabsContent value="auditoria">
        <PagosAuditoriaSection />
      </TabsContent>
    </Tabs>
  );
}
